import React, { useEffect, useRef } from 'react';

/**
 * Desktop shell keeps the current fixed-header + snap-scroll behavior.
 */
const AppShellDesktop = ({ header, footer, children }) => {
  const headerRef = useRef(null);

  useEffect(() => {
    const update = () => {
      const currentHeader = headerRef.current;
      if (currentHeader) {
        const h = currentHeader.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--header-h', `${h}px`);
      }
    };

    update();
    const ro = new ResizeObserver(update);
    const headerEl = headerRef.current;
    if (headerEl) ro.observe(headerEl);

    window.addEventListener('resize', update);

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', update);
    };
  }, []);

  return (
    <div className="app">
      <header ref={headerRef} className="header">
        {header}
      </header>

      <main className="main">
        <div className="scroller">
          {children}
          {footer && (
            <div className="footer-wrapper" id="footer">
              {footer}
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default AppShellDesktop;
